import React from 'react'
import './CategoryCards.css'
import { useNavigate } from 'react-router-dom'
import menCatImg from '../Assets/for-mens.jpg' // keep this img for mens
import womenCatImg from '../Assets/for-woman.jpg'
import kidsCatImg from '../Assets/for-kids.jpg'
import otherCatImg from '../Assets/for-other.jpg'

const CATEGORIES = [
    { key: 'women', label: 'Women', position: 'center top', size: 'large', image: womenCatImg },
    { key: 'kids', label: 'Kids', position: 'center center', size: 'small', image: kidsCatImg },
    { key: 'men', label: 'Men', position: 'center top', size: 'large', image: menCatImg },
    { key: 'other', label: 'Other', position: 'center center', size: 'small', image: otherCatImg },
]

const CategoryCards = () => {

    const navigate = useNavigate()

    // Get the first available product image for each category       IF GOING TO USE THIS NEED IMPORT ShopContext
    // const getCategoryImage = (categoryKey) => {
    //     const product = all_products.find(
    //         p => p.category === categoryKey && p.images && p.images.length > 0
    //     )
    //     return product ? product.images[0] : null
    // }

    const handleClick = (categoryKey) => {
        window.scrollTo(0, 0)
        navigate(`/shop-products?category=${categoryKey}`)
    }

    return (
        <div className="category-cards">
            <h2 className="cc-title">Shop by Category</h2>

            <div className="cc-grid">
                {CATEGORIES.map(cat => {
                    // const image = getCategoryImage(cat.key)
                    return (
                        <div
                            key={cat.key}
                            className={`cc-card cc-card--${cat.size} cc-card--${cat.key}`}
                            onClick={() => handleClick(cat.key)}
                            style={cat.image ? {
                                backgroundImage: `url(${cat.image})`,
                                backgroundPosition: cat.position
                            } : {}}
                        >
                            <div className="cc-overlay" />
                            <div className="cc-content">
                                <span className="cc-label">{cat.label}</span>
                                <span className="cc-cta">Shop Now →</span>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default CategoryCards